import { render, staticRenderFns } from "./SummaryConfigurationTab.vue?vue&type=template&id=d02f6b44&scoped=true&"
import script from "./SummaryConfigurationTab.vue?vue&type=script&lang=js&"
export * from "./SummaryConfigurationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02f6b44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d02f6b44')) {
      api.createRecord('d02f6b44', component.options)
    } else {
      api.reload('d02f6b44', component.options)
    }
    module.hot.accept("./SummaryConfigurationTab.vue?vue&type=template&id=d02f6b44&scoped=true&", function () {
      api.rerender('d02f6b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/components/SummaryConfigurationTab.vue"
export default component.exports